<template>
  <div class="body">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chấm công bổ sung/ Nghỉ phép</h1>

      <div class="float-right">
        <a @click="$router.go(-1)" class="f12 font-medium btn btn-outline-secondary mr-2">
          <i class="bx bx-arrow-back"></i> Quay lại
        </a>
        <button type="button" @click="submit('save')" class="f12 font-medium btn btn-success mr-2">
          <i class="bx bx-save"></i> Cập nhật
        </button>
        <button type="button" @click="submit('approved')" class="f12 font-medium btn btn-primary">
          <i class="bx bx-send"></i> Gửi duyệt
        </button>
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <!-- <div class="alert alert-warning alert-dismissible fade show" role="alert">
        <strong>Thông báo!</strong> Bạn đã hết ngày phép.
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->
      <div class="card-body px-20 row">
        <ValidationObserver
          ref="attdAdd"
          class="card-body px-20 mt-2 row"
          style="min-height: 600px"
        >
          <form class="col-md-6">
            <div
              class="form-group row"
              v-if="
                (dataInsert.type === 'ATTN_ADD' &&
                  !typeCheckInOut.includes(dataInsert.reasonAttnAdd)) ||
                dataInsert.type !== 'ATTN_ADD'
              "
            >
              <div class="offset-sm-3 col-sm-9">
                <div class="checkbox">
                  <input
                    class="inp-cbx"
                    id="cbx01"
                    v-model="dataInsert.isMultiDay"
                    type="checkbox"
                    style="display: none"
                  />
                  <label class="cbx" for="cbx01">
                    <span>
                      <svg width="12px" height="10px" viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                    Đăng ký nghỉ nhiều ngày
                  </label>
                </div>
                <p class="form-text text-muted well">
                  Đăng ký nghỉ nhiều ngày chỉ tính cho quên chấm công cả ngày hoặc nghỉ liên tục.
                  Quên check in hoặc check out hãy đăng ký riêng.
                </p>
              </div>
            </div>
            <ValidationProvider rules="required" vid="type" name="Kiểu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Kiểu <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataInsert.type"
                    :options="typeAddanceTimeKepping"
                    placeholder="Kiểu"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-if="dataInsert.type === 'ATTN_ADD'"
              rules="required"
              vid="reasonAttnAdd"
              name="Loại"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-3 col-form-label"
                  >Loại chấm công <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataInsert.reasonAttnAdd"
                    :options="listReason"
                    placeholder="Loại chấm công"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              v-if="
                dataInsert.type === 'ATTN_ADD' && typeCheckInOut.includes(dataInsert.reasonAttnAdd)
              "
            >
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"
                  >Thời gian <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="form-row">
                    <div class="col-12">
                      <datepicker
                        format="dd/MM/yyyy"
                        :language="vi"
                        v-model="dateCheckinCheckout"
                        placeholder="Chọn ngày"
                      ></datepicker>
                    </div>
                  </div>
                </div>
              </div>
            </ValidationProvider>

            <div v-else>
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label"
                  >Bắt đầu <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="form-row">
                    <div class="col-12">
                      <DateRangePicker
                        :ranges="false"
                        v-model="dateRange"
                        :locale-data="localeData"
                        class="w-100"
                        :timePicker="true"
                        :timePicker24Hour="true"
                      >
                        <template v-slot:input="picker">
                          <label style="min-width: 13.5em" class="text-left pt-1"
                            ><span class="text-info">Ngày </span> :
                            {{ picker.startDate | formatDate }} |
                            <span class="text-info">Giờ </span> :
                            {{ dateRange.startDate | formatDate('HH:mm DD/MM/YYYY') }}</label
                          >
                        </template>
                      </DateRangePicker>
                      <span class="icon-calendar"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label"
                  >Kết thúc <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="form-row">
                    <div class="col-12">
                      <DateRangePicker
                        :ranges="false"
                        v-model="dateRange"
                        :locale-data="localeData"
                        class="w-100"
                        :timePicker="true"
                        :timePicker24Hour="true"
                      >
                        <template v-slot:input="picker">
                          <label style="min-width: 13.5em" class="text-left pt-1"
                            ><span class="text-info">Ngày </span> :
                            {{ picker.endDate | formatDate }} |
                            <span class="text-info">Giờ </span> :
                            {{ dateRange.endDate | formatDate('HH:mm DD/MM/YYYY') }}</label
                          >
                        </template>
                      </DateRangePicker>
                      <span class="icon-calendar"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
              <div class="col-sm-9">
                <textarea class="form-control" rows="2" v-model="dataInsert.note"></textarea>
              </div>
            </div>
          </form>

          <form class="col-md-6">
            <h1 class="form-inner-heading">Ảnh đính kèm</h1>
            <div class="form-group row img-list mr-0 ml-0">
              <ul>
                <li v-for="(image, index) in imageDataOld" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="image" alt="" />
                    <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                  </a>
                </li>
                <li>
                  <div class="add-img">
                    <span class="bx bx-plus text-center"></span>
                    <input @input="onSelectFile" ref="fileInput" type="file" />
                  </div>
                </li>
              </ul>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="light"
          v-if="successOrfalse == true"
          @click="closeModalSuccess()"
        >
          Đóng
        </b-button>
        <b-button size="sm" variant="light" v-else @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import thirdParty from '../../thirdParty/config'
  import { AttentdentService } from '@/services/attentdent.service'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        dataInsert: {
          isMultiDay: false,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        localeData: thirdParty.localeData,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        successOrfalse: false,
        listReason: thirdParty.listReason,
        arrayFormData: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        imageData: [],
        imageDataOld: [],
        dateCheckinCheckout: null,
        vi: vi,
        typeCheckInOut: ['FORGOT_ATTN_IN', 'FORGOT_ATTN_OUT'],
        showLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        typeAddanceTimeKepping: 'common/typeAddanceTimeKepping',
      }),
    },
    created() {
      const id = this.$route.params.id
      this.fetchData(id)
    },

    methods: {
      // lấy thông tin bản ccbs qua id
      async fetchData(id) {
        try {
          this.loading = true
          const resp = await AttentdentService.timekeepingDetail({
            id: id,
          })
          if (resp.code === 1000) {
            this.dataInsert = resp.data
            this.dateRange.startDate = this.dateCheckinCheckout = resp.data.startDate
            this.dateRange.endDate = resp.data.endDate
            this.imageDataOld = resp.data.imageUrl
            this.loading = false
          }
        } catch (e) {
          this.error = e.message
        } finally {
          this.loading = false
        }
      },
      // update [submit('save')], gửi duyệt [submit('approved')]
      async submit(key) {
        try {
          const isSuccess = await this.$refs.attdAdd.validate()
          if (!isSuccess) {
            return
          }
          this.showLoading = true
          this.convertBeforeSubmit(key)
          this.convertCheckInOut()
          const res = await AttentdentService.timekeepingEdit(this.dataInsert)
          if (res.code === 1000) {
            this.notiModal = true
            this.msgNoti = 'Cập nhật thành công'
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.successOrfalse = true
            return
          }
          this.notiModal = true
          this.msgNoti = res.message || 'Cập nhật thất bại'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.successOrfalse = false
        } catch (e) {
          this.notiModal = true
          this.msgNoti = 'Lỗi hệ thống'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.successOrfalse = false
        } finally {
          this.showLoading = false
        }
      },

      async convertBeforeSubmit(key) {
        if (key === 'save') this.dataInsert.isSubmit = false
        if (key === 'approved') this.dataInsert.isSubmit = true
        this.dataInsert.startDate = moment(this.dateRange.startDate).valueOf()
        this.dataInsert.endDate = moment(this.dateRange.endDate).valueOf()
        this.dataInsert.userId = this.dataUser.userId
        this.dataInsert.imageUrl = this.imageDataOld
        if (this.dataInsert.type !== 'ATTN_ADD') {
          delete this.dataInsert.reasonAttnAdd
          delete this.dataInsert.reasonString
        }
        const typeString = this.typeAddanceTimeKepping.find(a => a.id === this.dataInsert.type)
        this.dataInsert.typeString = typeString.text
      },

      convertCheckInOut() {
        if (
          this.dataInsert.type === 'ATTN_ADD' &&
          this.typeCheckInOut.includes(this.dataInsert.reasonAttnAdd)
        ) {
          delete this.dataInsert.endDate
          this.dataInsert.isMultiDay = false
          this.dataInsert.startDate = moment(
            new Date(this.dateCheckinCheckout).setHours(8, 30)
          ).valueOf()
          if (this.dataInsert.reasonAttnAdd === 'FORGOT_ATTN_IN')
            this.dataInsert.reasonString = 'Bổ sung Checkin'
          else this.dataInsert.reasonString = 'Bổ sung Checkout'
        }
      },

      // thêm ảnh: call api upload ảnh khi thêm ảnh => link ảnh mới => gộp với ảnh cũ đẩy vào api update
      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        this.formData = new FormData()
        this.formData.append('files', files[0])
        this.formData.append('folderName', 'NextCrm')
        this.arrayFormData.push(this.formData)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await CommonService.uploadImg(this.formData).then(ee => {
          if (ee.code === 1000) {
            this.imageDataOld.push(ee.data[0])
          }
        })
      },
      // xóa ảnh: xóa từ arr gộp ở trên
      removeImg(index) {
        this.imageDataOld.splice(index, 1)
      },
      // khi thao tác thành công => quay lại trang ccbs
      closeModalSuccess() {
        this.$router.push({ path: `/timekeeping/${this.dataInsert.id}` })
        this.notiModal = false
      },
    },
  }
</script>
